<template>
    <div class="q-mb-md">
        <div class="text-subtitle2 q-mb-sm">
            {{ label }}
            <q-icon name="help_outline" size="xs"
                ><q-tooltip>{{ helpText }}</q-tooltip></q-icon
            >
        </div>

        <div
            v-for="(item, index) in items"
            :key="index"
            class="q-mb-md q-pa-md bg-grey-2 rounded-borders"
        >
            <div class="row items-center justify-between q-mb-sm">
                <div class="text-weight-bold">Question {{ index + 1 }}</div>
                <q-btn
                    flat
                    dense
                    color="negative"
                    icon="delete"
                    @click="removeItem(index)"
                />
            </div>
            <q-input
                v-model="item.label"
                dense
                outlined
                label="Question/Label"
                class="q-mb-md"
            />
            <q-select
                v-model="item.options"
                use-input
                use-chips
                multiple
                hide-dropdown-icon
                input-debounce="0"
                new-value-mode="add-unique"
                dense
                outlined
                label="Options (Type and press Enter)"
            />
        </div>

        <q-btn
            outline
            color="primary"
            icon="add"
            label="Add Question"
            @click="addItem"
        />
        <input type="hidden" :name="name" :value="jsonString" />
    </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";

export default {
    name: "AdditionalInfoEditor",
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        helpText: {
            type: String,
            default: "",
        },
    },
    setup(props) {
        const items = ref([]);

        onMounted(() => {
            if (props.value) {
                if (props.value.startsWith("[") && props.value.endsWith("]")) {
                    try {
                        items.value = JSON.parse(props.value);
                    } catch (e) {
                        console.error("Failed to parse JSON", e);
                        parseLegacy(props.value);
                    }
                } else {
                    parseLegacy(props.value);
                }
            }
        });

        const parseLegacy = (data) => {
            const result = [];
            const selections = data.split(";");
            for (const selection of selections) {
                const parts = selection.split(":");
                if (parts.length >= 2 && parts[0].trim() && parts[1].trim()) {
                    result.push({
                        label: parts[0].trim(),
                        options: parts[1]
                            .split(",")
                            .map((o) => o.trim())
                            .filter((o) => o),
                    });
                }
            }
            items.value = result;
        };

        const addItem = () => {
            items.value.push({ label: "", options: [] });
        };

        const removeItem = (index) => {
            items.value.splice(index, 1);
        };

        const jsonString = computed(() => {
            // filter out empty
            const validItems = items.value.filter(
                (i) => i.label.trim() !== "" && i.options.length > 0,
            );
            return validItems.length > 0 ? JSON.stringify(validItems) : "";
        });

        return {
            items,
            addItem,
            removeItem,
            jsonString,
        };
    },
};
</script>
